"use client";

import React from 'react';
import { useStore } from '@/context/StoreContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTruckFast,
    faCreditCard,
    faShieldHalved,
    faHeadset,
    faGift,
    faTag,
    faRotateLeft,
    faLock,
    faStar,
    faBagShopping,
    IconDefinition
} from '@fortawesome/free-solid-svg-icons';

const ICON_MAP: Record<string, IconDefinition> = {
    'truck': faTruckFast,
    'truck-fast': faTruckFast,
    'credit-card': faCreditCard,
    'card': faCreditCard,
    'shield': faShieldHalved,
    'shield-check': faShieldHalved,
    'shield-alt': faShieldHalved,
    'shield-halved': faShieldHalved,
    'headset': faHeadset,
    'support': faHeadset,
    'gift': faGift,
    'tag': faTag,
    'discount': faTag,
    'rotate-left': faRotateLeft,
    'undo': faRotateLeft,
    'exchange': faRotateLeft,
    'lock': faLock,
    'star': faStar,
    'bag': faBagShopping,
    'shopping-bag': faBagShopping,
    'shopping-cart': faBagShopping,
    'cart': faBagShopping,
};

const DEFAULT_BENEFITS = [
    {
        icon: 'truck',
        title: 'Entrega Segura',
        subtitle: 'Envio rápido para todo o Brasil'
    },
    {
        icon: 'credit-card',
        title: 'Parcele em até 12x',
        subtitle: 'Ou desconto especial no PIX'
    },
    {
        icon: 'shield-check',
        title: 'Compra Protegida',
        subtitle: 'Dados criptografados e 100% seguros'
    },
    {
        icon: 'headset',
        title: 'Suporte Humanizado',
        subtitle: 'Atendimento direto no WhatsApp'
    }
];

export default function BenefitsBar() {
    const { settings } = useStore();

    // Se o lojista explicitamente desativou a barra de benefícios, não renderiza
    if (settings.benefits_bar?.is_active === false) {
        return null;
    }

    // Se for delivery/food, esconde se não estiver explicitamente ativado
    if (settings.catalog_type === 'food' && !settings.benefits_bar?.is_active) {
        return null;
    }

    const items = (settings.benefits_bar?.items && settings.benefits_bar.items.length > 0)
        ? settings.benefits_bar.items
        : DEFAULT_BENEFITS;

    return (
        <section className="w-full mb-8 md:mb-12">
            <div className="container mx-auto px-4">
                <div className="bg-white rounded-2xl md:rounded-3xl border border-gray-100 shadow-sm p-4 md:p-6 transition-all hover:shadow-md">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 divide-y md:divide-y-0 md:divide-x divide-gray-100">
                        {items.slice(0, 4).map((item, index) => {
                            const iconKey = (item.icon || '').toLowerCase().trim();
                            const iconDef = ICON_MAP[iconKey] || faShieldHalved;
                            return (
                                <div 
                                    key={index} 
                                    className={`flex items-center gap-3.5 group p-2 md:px-4 ${index > 0 ? 'pt-4 md:pt-2' : ''}`}
                                >
                                    <div className="w-11 h-11 md:w-12 md:h-12 rounded-2xl bg-[var(--primary)]/10 text-[var(--primary)] flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110 shadow-sm">
                                        <FontAwesomeIcon icon={iconDef} className="text-lg md:text-xl" />
                                    </div>
                                    <div className="flex flex-col min-w-0">
                                        <h4 className="text-xs md:text-sm font-bold text-gray-800 leading-snug truncate group-hover:text-[var(--primary)] transition-colors">
                                            {item.title}
                                        </h4>
                                        <p className="text-[11px] md:text-xs text-gray-500 leading-tight line-clamp-1 mt-0.5">
                                            {item.subtitle}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
